export enum ReportBoxValueDataTypeEnum {
    String = 1,
    Number,
    Percentage,
    Currency
}
